import Map from "./Map";

const Home = () => {
  return (
    <div>
      <Map />
    </div>
  );
};

export default Home;
